/**
 * Simple pub/sub events system for cross-component communication
 */

// Event types
export const EVENTS = {
  USER_TENANT_UPDATED: 'user-tenant-updated',
  USER_LIST_REFRESH: 'user-list-refresh',
};

// Subscribers map
const subscribers = new Map();

/**
 * Subscribe to an event
 * @param {string} eventName - Event name to subscribe to
 * @param {function} callback - Callback to execute when event is triggered
 * @returns {function} Unsubscribe function
 */
export const subscribe = (eventName, callback) => {
  if (!subscribers.has(eventName)) {
    subscribers.set(eventName, new Set());
  }

  const eventSubscribers = subscribers.get(eventName);
  eventSubscribers.add(callback);

  // Return unsubscribe function
  return () => {
    const eventSubscribers = subscribers.get(eventName);
    if (eventSubscribers) {
      eventSubscribers.delete(callback);
    }
  };
};

/**
 * Publish an event
 * @param {string} eventName - Event name to publish
 * @param {any} data - Data to pass to subscribers
 */
export const publish = (eventName, data) => {
  const eventSubscribers = subscribers.get(eventName);
  if (eventSubscribers) {
    eventSubscribers.forEach(callback => {
      try {
        callback(data);
      } catch (err) {
        console.error(`Error in event handler for ${eventName}:`, err);
      }
    });
  }
};
